var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoBrandsMainSettings24X24 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "incon_main_settings24x24",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_27014",
    "data-name": "Group 27014",
    transform: "translate(-20 -113)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10974",
    "data-name": "Rectangle 10974",
    width: 24,
    height: 24,
    transform: "translate(20 113)",
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "ico_brand_settings24x24",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "settings_2_",
    "data-name": "settings (2)",
    d: "M15.176,6.222h-1.5a.575.575,0,0,1-.406-.978l1.059-1.058a.824.824,0,0,0,0-1.165L12.978,1.668a.844.844,0,0,0-1.165,0L10.756,2.727a.556.556,0,0,1-.4.17.6.6,0,0,1-.4-.16.555.555,0,0,1-.178-.417V.824A.825.825,0,0,0,8.954,0H7.046a.825.825,0,0,0-.824.824v1.5a.573.573,0,0,1-.581.576.557.557,0,0,1-.4-.17L4.183,1.669a.844.844,0,0,0-1.165,0L1.668,3.018a.824.824,0,0,0,0,1.165L2.727,5.244a.575.575,0,0,1-.406.978H.824A.825.825,0,0,0,0,7.046V8.954a.825.825,0,0,0,.824.824h1.5a.575.575,0,0,1,.406.978L1.668,11.813a.824.824,0,0,0,0,1.165l1.349,1.349a.843.843,0,0,0,1.165,0L5.241,13.27a.556.556,0,0,1,.4-.17.573.573,0,0,1,.58.579v1.5A.824.824,0,0,0,7.046,16H8.954a.825.825,0,0,0,.824-.824v-1.5a.573.573,0,0,1,.58-.576.557.557,0,0,1,.4.17l1.058,1.058a.844.844,0,0,0,1.165,0l1.349-1.349a.824.824,0,0,0,0-1.165l-1.059-1.06a.575.575,0,0,1,.406-.978h1.5A.825.825,0,0,0,16,8.954V7.046A.825.825,0,0,0,15.176,6.222ZM10.074,8A2.074,2.074,0,1,1,8,5.926,2.074,2.074,0,0,1,10.074,8Z",
    transform: "translate(3 3)",
    fill: "#999"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoBrandsMainSettings24X24);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_brands_main_settings24x24.bed71e324fa53c50234c7eaab24fa0c1.svg";